import React, { useState } from 'react';
import { Upload, X, FileText, Image as ImageIcon, Loader2, Info } from 'lucide-react';
import { uploadFile, resolveImg } from '../../lib/api';
import { IMAGE_SPECS } from '../../lib/imageSpecs';

export default function ImageUploader({ value, onChange, folder = 'general', specKey = 'general', accept = 'image/*' }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const spec = IMAGE_SPECS[specKey] || IMAGE_SPECS.general;

  const handleFile = async (file) => {
    if (!file) return;
    setUploading(true);
    setError('');
    try {
      const res = await uploadFile(file, folder);
      onChange(res.url);
    } catch (e) {
      setError(e.response?.data?.detail || 'Error al subir');
    }
    setUploading(false);
  };

  const isPdf = value && (value.endsWith('.pdf') || value.includes('.pdf?'));

  return (
    <div className="space-y-2">
      <div className="bg-amber-500/5 border border-amber-500/20 rounded p-3 text-xs text-amber-200/80 flex gap-2">
        <Info size={14} className="flex-shrink-0 mt-0.5 text-amber-400" />
        <div className="space-y-0.5">
          <div className="font-medium text-amber-300">{spec.label}</div>
          <div>
            {spec.width && <>Tamaño recomendado: <strong>{spec.width}×{spec.height || '?'} px</strong> ({spec.ratio || 'libre'}) · </>}
            Peso máximo: <strong>{spec.maxKB} KB</strong> · Formatos: {spec.formats}
          </div>
          {spec.note && <div className="text-amber-200/60 italic">{spec.note}</div>}
        </div>
      </div>

      <div className="flex items-start gap-3">
        {value ? (
          <div className="relative w-32 h-20 bg-zinc-900 border border-white/10 overflow-hidden flex-shrink-0 flex items-center justify-center">
            {isPdf ? (
              <FileText size={28} className="text-[#c9a063]" />
            ) : (
              <img src={resolveImg(value)} alt="preview" className="w-full h-full object-cover" />
            )}
            <button type="button" onClick={() => onChange('')} className="absolute top-1 right-1 bg-black/70 text-white p-0.5 hover:bg-red-600"><X size={12} /></button>
          </div>
        ) : (
          <div className="w-32 h-20 border border-dashed border-white/15 flex items-center justify-center text-white/30 flex-shrink-0"><ImageIcon size={24} /></div>
        )}

        <div className="flex-1 min-w-0">
          <label className="inline-flex items-center gap-2 px-4 py-2 bg-zinc-900 border border-white/15 text-white/80 text-xs uppercase tracking-widest cursor-pointer hover:border-[#c9a063] hover:text-[#c9a063] transition-colors">
            {uploading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
            {uploading ? 'Subiendo...' : 'Subir archivo'}
            <input type="file" accept={accept} className="hidden" onChange={(e) => handleFile(e.target.files?.[0])} disabled={uploading} />
          </label>
          <input type="text" value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder="o pega una URL externa" className="mt-2 w-full bg-zinc-950 border border-white/10 text-white/80 px-3 py-2 text-xs focus:border-[#c9a063] focus:outline-none" />
          {error && <div className="text-red-400 text-xs mt-1">{error}</div>}
        </div>
      </div>
    </div>
  );
}
